export default __webpack_public_path__ + "static/media/footer_PO_default.eef4570a.png";